import React from "react";
import { FormattedMessage } from "react-intl";
import { FixedFooterPageItem, FooterItem } from "../FixedFooterPageItem";
import { Grid } from "@material-ui/core";
import Number from "../../../custom/Number";

const FooterFinancialSummary = ({ commissionGenerated, summary, showCommissionValue, hiddenValues }) => {
  const { contractsActive = 0, custodialValue = 0 } = summary || {};
  const activeContracts = contractsActive;
  const custodyValue = custodialValue;

  const getContractsLabel = () => {
    if (activeContracts === 0) return <FormattedMessage id="app.none" />;
    if (activeContracts === 1) return <FormattedMessage id="app.contracts.quantity.one" />;
    return (
      <FormattedMessage
        id="app.contracts.quantity"
        values={{ quantity: activeContracts }}
      />
    );
  };

  return (
    <FixedFooterPageItem>
      <Grid
        container
        justifyContent={showCommissionValue ? "space-between" : "flex-end"}
      >
        {showCommissionValue && (
          <Grid item>
            <FooterItem
              variant="body1"
              title={<FormattedMessage id="app.comission.lct" />}
              subtitle={
                <Number
                  value={commissionGenerated}
                  currency="LCT"
                  hideValue={hiddenValues}
                />
              }
            />
          </Grid>
        )}
        <Grid item>
          <FooterItem
            variant="body1"
            title={getContractsLabel()}
            subtitle={
              <>
                <FormattedMessage id="app.total" />:
                <Number
                  value={custodyValue}
                  currency="LCT"
                  hideValue={hiddenValues}
                />
              </>
            }
            align="right"
          />
        </Grid>
      </Grid>
    </FixedFooterPageItem>
  );
};

export default React.memo(FooterFinancialSummary);
